<template>
  <section v-if="usersChatRoomIds !== null"  class="h-full bg-purple-600 bg-gradient-to-t from-purple-600 via-purple-500 to-purple-600 rounded-xl flex flex-col justify-between relative">

    <div class="px-5 space-y-4 md:space-x-0 md:p-2 absolute top-1/2 md:top-0 transform -translate-y-1/2 w-full z-20 md:static md:translate-y-0">

      <div @click="$emit('createChatRoom')" class="pop-click p-10 md:p-4 bg-purple-400 rounded-xl text-white text-center uppercase flex justify-center space-y-4 h-36 md:h-auto w-full mx-auto flex-col max-w-sm">
        <ion-icon class="text-4xl md:text-3xl lg:text-5xl table mx-auto md:my-auto" name="add-circle"></ion-icon>
        <h6 class="text-2xl md:text-lg table my-auto">Create Chat Room</h6>
      </div>

      <div @click="$emit('toggleIsDiscoverExpanded',true)" class="pop-click p-10 md:p-4 bg-purple-400 rounded-xl text-white text-center uppercase flex justify-center space-y-4 md:space-y-0 md:space-x-1 h-36 w-full md:h-auto mx-auto flex-col md:flex-row md:hidden max-w-sm">
        <ion-icon class="text-4xl md:text-2xl table mx-auto md:my-auto" name="person-add"></ion-icon>
        <h6 class="text-2xl md:text-xs table my-auto">Join Chat Room</h6>
      </div>

    </div>
    

    <div class="hidden md:block" >
      <img class="mx-auto" src="/sidebar_add_chat.svg" alt="Person Choosing">
    </div>
  </section>
</template>

<script>
export default {
  props : {
    isAtLargeScreen : Boolean,
    usersChatRoomIds : Array
  },
  emits : ['createChatRoom','toggleIsDiscoverExpanded'],
}
</script>

<style>

</style>